import { PageRef } from 'providers/page-ref';

export type SendCoachMessagePageParams = {};

export const ISendCoachMessagePage: PageRef<SendCoachMessagePageParams, void> = {
  pageName: 'SendCoachMessagePage',
} as PageRef<SendCoachMessagePageParams, void>;
